(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Pharmacy', Pharmacy);

    Pharmacy.$inject = ['$resource'];

    function Pharmacy ($resource) {
        var resourceUrl =  'api/pharmacy/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {url: 'api/pharmacy/filter', method: 'GET', isArray: true}
        });
    }
})();
